import React from "react"

export const LogoM = ({color = '#FE705A'}: {color: string}) => {
  return(
		<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 50.1 49.7" xmlSpace="preserve">
		<g>
			<g>
				<path style={{fill: color}} className="st0" d="M1.1,16.4c0-6.2,3.8-11.8,9.9-13.3c10.1-2.5,25.4-4.5,32.9,3c6.3,6.3,5.9,18.2,4.1,27.8
					c-1.7,9.2-10.2,14.9-19.6,14.9H8.6c-4.1,0-7.5-3.4-7.5-7.5V16.4z"/>
			</g>
		</g>
		<g>
			<path style={{fill:"#FFFFFF"}} className="st1" d="M25.6,27.2l0.3-0.7c2.3-5.2,4-8.6,5-10.1c0.2-0.2,0.3-0.4,0.4-0.5c0.1-0.1,0.3-0.2,0.4-0.3
				c0.2-0.1,0.3-0.2,0.6-0.3c0.7-0.3,1.6-0.5,2.7-0.5c0.6,0,0.9,0,1.1,0.1c0.2,0.1,0.2,0.3,0.2,0.7c0,0.3,0,0.5,0,0.8
				c-0.1,1.8-0.1,3-0.1,3.8c0,1.9,0.1,3.7,0.4,5.3c0.2,0.9,0.4,1.9,0.7,2.9c0.3,0.9,0.7,1.5,1,2c0.4,0.5,0.7,0.9,0.9,1.1
				c0.3,0.3,0.5,0.6,0.5,0.7c0,0.3-0.3,0.7-0.8,1.2c-0.9,0.8-1.7,1.3-2.6,1.3c-1.2,0-2.3-0.5-3.3-1.6c-0.5-0.5-0.9-1.1-1.2-1.7
				c-0.3-0.6-0.5-1.4-0.7-2.3s-0.2-2.1-0.3-3.5c-0.1-1.5-0.1-2.4-0.1-2.6h-0.1c-0.6,1.2-1.1,2.2-1.5,3s-0.7,1.4-1,2
				c-0.3,0.5-0.6,1.1-0.9,1.9c-1.1,2.3-1.8,3.7-2.2,4.2c0,0-0.1,0.1-0.1,0.1s-0.1,0.1-0.2,0.2c-0.2,0.2-0.4,0.3-0.6,0.4
				c-0.2,0.1-0.4,0.1-0.5,0.1c-0.4,0-0.9-0.3-1.4-0.8s-0.9-1.2-1.3-2c-0.4-0.9-0.7-1.7-0.9-2.6c-0.2-0.9-0.5-2-0.6-3.2
				c-0.2-1.2-0.3-2.7-0.5-4.5h-0.1c-0.3,0.6-0.5,1.1-0.7,1.4s-0.4,0.8-0.7,1.5c-0.3,0.7-0.5,1.1-0.5,1.2c-0.4,0.9-0.8,1.8-1.3,2.7
				c-0.4,0.9-0.8,1.6-1.1,2.1c-0.3,0.5-0.6,1-0.9,1.5c-0.1,0.2-0.4,0.5-0.8,1c-0.6,0.5-1.2,1-1.9,1.3c-0.7,0.3-1.3,0.5-1.9,0.5
				c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0.1-0.4,0.4-0.7c0.1-0.2,0.5-0.6,1-1.3l0.9-1.3c0.5-0.8,1.3-2.2,2.4-4.2
				l0.7-1.3c1.6-3.1,2.8-5.3,3.3-6.5s0.9-1.8,0.9-2c0-0.2-0.1-0.4-0.4-0.7c-0.2-0.2-0.3-0.3-0.3-0.5c0-0.2,0.3-0.4,0.8-0.6
				s1.2-0.3,1.8-0.3c1.3,0,2.3,0.3,2.9,0.9c0.4,0.4,0.7,1.1,1,2.2s0.6,2.7,0.9,4.7c0,0.1,0,0.2,0,0.3s0,0.1,0,0.2c0,0,0,0.1,0,0.2
				c0.1,0.3,0.1,0.5,0.1,0.5c0.2,1.3,0.4,2.1,0.5,2.4C25.3,26.6,25.4,26.9,25.6,27.2z"/>
		</g>
		</svg>
  )
}